var _path, _path2, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalculator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.61493 17.1129C5.82629 18.3333 7.77595 18.3333 11.6753 18.3333C15.5746 18.3333 17.5242 18.3333 18.7356 17.1129C19.947 15.8925 19.947 13.9283 19.947 9.99996C19.947 6.07159 19.947 4.1074 18.7356 2.88701C17.5242 1.66663 15.5746 1.66663 11.6753 1.66663C7.77595 1.66663 5.82629 1.66663 4.61493 2.88701C3.40356 4.1074 3.40356 6.07159 3.40356 9.99996C3.40356 13.9283 3.40356 15.8925 4.61493 17.1129Z",
    stroke: "#083342",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.07983 6.66667C7.07983 6.27918 7.07983 6.08543 7.12681 5.92648C7.25429 5.49511 7.62589 5.15818 8.10164 5.04259C8.27695 5 8.49063 5 8.91799 5H14.4325C14.8598 5 15.0735 5 15.2488 5.04259C15.7246 5.15818 16.0962 5.49511 16.2236 5.92648C16.2706 6.08543 16.2706 6.27918 16.2706 6.66667C16.2706 7.05415 16.2706 7.2479 16.2236 7.40686C16.0962 7.83822 15.7246 8.17516 15.2488 8.29074C15.0735 8.33333 14.8598 8.33333 14.4325 8.33333H8.91799C8.49063 8.33333 8.27695 8.33333 8.10164 8.29074C7.62589 8.17516 7.25429 7.83822 7.12681 7.40686C7.07983 7.2479 7.07983 7.05415 7.07983 6.66667Z",
    stroke: "#083342",
    strokeWidth: 1.5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.99891,
    cy: 10.8333,
    rx: 0.919078,
    ry: 0.833333,
    fill: "#083342"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.99891,
    cy: 14.1667,
    rx: 0.919078,
    ry: 0.833333,
    fill: "#083342"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.6752,
    cy: 10.8333,
    rx: 0.919078,
    ry: 0.833333,
    fill: "#083342"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.6752,
    cy: 14.1667,
    rx: 0.919078,
    ry: 0.833333,
    fill: "#083342"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.3516,
    cy: 10.8333,
    rx: 0.919078,
    ry: 0.833333,
    fill: "#083342"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.3516,
    cy: 14.1667,
    rx: 0.919078,
    ry: 0.833333,
    fill: "#083342"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/calculator.31bcefa4fc72acbff187520fba4b9c6d.svg";
export { ForwardRef as ReactComponent };